export default (arr, fn) =>
    arr.map(typeof fn === 'function' ? fn : (val) => val[fn]).reduce((acc, val, i) => {
        acc[val] = (acc[val] || []).concat(arr[i]);
        return acc;
    }, {});
